import { styled } from '@mui/system';
import { Typography } from '@mui/material';

interface ButtonProps {
  alternative?: boolean;
  disabled?: boolean;
}

const ButtonDiv = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  bottom: '0',
  width: '100%',
  height: '80px',
  backgroundColor: 'white',
  borderTop: '1px solid #EAEAEA',
  zIndex: 2,
  '@media (min-width: 900px)': {
    position: 'sticky',
  },
});

const Button = styled('button', {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<ButtonProps>(({ disabled, theme }) => ({
  backgroundColor: disabled ? '#EAEAEA' : '#0A7ABE',
  borderRadius: '100px',
  padding: '8px 60px',
  cursor: disabled ? 'default' : 'pointer',
  border: 'none',
  transition: 'all 0.3s ease-in-out',
  color: 'white',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  [theme.breakpoints.down(330)]: {
    padding: '8px 40px',
  },
  [theme.breakpoints.down(275)]: {
    padding: '8px 20px',
  },
}));

const TypographyButton = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  [theme.breakpoints.down(400)]: {
    fontSize: '14px',
  },
  [theme.breakpoints.down(275)]: {
    fontSize: '12px',
  },
}));

export { ButtonDiv, Button, TypographyButton };
